import { Component, HostListener, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { constObj } from '../../Constants/constants';
import { CommonDataService } from '../../services/common-data.service';
import { CrSortingService } from '../../services/cr-sorting.service';
import { GraphqlService } from '../../services/graphql.service';
import { OpenLinkById } from '../../services/openlinkbyid';

@Component({
  selector: 'app-cross-reference-table',
  templateUrl: './cross-reference-table.component.html',
  styleUrls: ['./cross-reference-table.component.css']
})
export class CrossReferenceTableComponent implements OnInit, OnChanges {
  @Input() is_cross_reference?: boolean = false;
  @Input() table_Columns: any;
  @Input() table_dataSource: MatTableDataSource<any[]>;
  @Input() table_data: any;
  @Input() table_sort_active: any;
  @Input() Collection: string;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  pagesize: any = 10;
  pagelistarray: any[] = [];
  userRole: string = "";
  noRecords = constObj.Norecords;
  data_length: number;
  displayedColumns: any;
  dataSource: any = [];

  constructor(private commonDataService: CommonDataService, private openlink: OpenLinkById, private graphQl: GraphqlService, private router: Router, private sttSort: CrSortingService) {
    this.dataSource = new MatTableDataSource<any>();
  }

  ngOnInit(): void {
    this.dataSource.data = this.table_dataSource?.data as unknown as any[];
    this.displayedColumns = this.table_Columns?.map((c) => c.columnDef);
    

    this.SelectedSearch = this.commonDataService.currentSortHeaderSTT.getValue();
    this.sortingColumn = this.SelectedSearch == "OP" ? "pronouncement" : (this.SelectedSearch == "COD" ? "section" : (this.SelectedSearch == "CIG" ? "chapter" : "pronouncement"));
    /* eslint-disable */
    this.sortingDirection = this.commonDataService.currentSortDirectionSTT.getValue() == '' || this.commonDataService.currentSortDirectionSTT.getValue() == 'asc' ? 'asc' : 'desc';
    /* eslint-enable */
    if (this.table_data) {
      this.table_data.sort((a, b) => this.sortProcess(a, b, this.sortingDirection));
    }
    this.dataSource.data = this.table_data;
    this.data_length = this.dataSource.length;
    this.displayedColumns = this.table_Columns.map((c) => c.columnDef);
    if (this.is_cross_reference) {
      this.pagesize = 50;
      if (this.table_dataSource.data.length > 100) {
        this.pagelistarray = [50, 100, this.table_dataSource.data.length];
      }
      else {
        this.pagelistarray = [50, 100];
      }
    }
  }
  SelectedSearch: string = '';
  ngOnChanges(changes: SimpleChanges) {
    this.SelectedSearch = this.commonDataService.currentSortHeaderSTT.getValue();
    this.sortingColumn = this.SelectedSearch == "Standard" ? "paragraph" : "standardType";
    this.sortingDirection = this.commonDataService.currentSortDirectionSTT.getValue() == '' || this.commonDataService.currentSortDirectionSTT.getValue() == 'asc' ? 'asc' : 'desc';
    if (changes.table_data != undefined) {
      this.dataSource.data = changes.table_data.currentValue.sort((a, b) => this.sortProcess(a, b, this.sortingDirection));
      this.data_length = this.dataSource.length;
      this.displayedColumns = this.table_Columns.map((c) => c.columnDef);
      if (this.is_cross_reference) {
        this.pagesize = 50;
        if (this.table_dataSource.data.length > 100) {
          this.pagelistarray = [50, 100, this.table_dataSource.data.length];
        }
        else {
          this.pagelistarray = [50, 100];
        }
      }
      this.table_dataSource.paginator = this.paginator;
      this.table_dataSource.sort = this.sort;
      this.table_dataSource.sortData = this.sortData();
    }
  }

  ngAfterViewInit() {
    this.table_dataSource.paginator = this.paginator;
    this.table_dataSource.sort = this.sort;
    this.table_dataSource.sortData = this.sortData();
  }


  sortingColumn: string = "";
  sortingDirection: any = 'asc';
  customSort(event) {
    this.sortingColumn = event.active;
    if (this.sortingColumn == "standardType") { this.commonDataService.currentSortHeaderSTT.next("Codification"); }
    else if (this.sortingColumn == "paragraphId") { this.commonDataService.currentSortHeaderSTT.next("Codification"); }
    else if (this.sortingColumn == "paragraph") { this.commonDataService.currentSortHeaderSTT.next("Standard"); }
    else if (this.sortingColumn == "topic") { this.commonDataService.currentSortHeaderSTT.next("Standard"); }
    this.sortingDirection = event.direction;
    if (this.sortingDirection == 'asc' || this.sortingDirection == '') { this.commonDataService.currentSortDirectionSTT.next('asc'); }
    else { this.commonDataService.currentSortDirectionSTT.next('desc'); }
  }

  sortData() {
    let sortFunction =
      (items: any[], ms: MatSort) => {
        if (!ms.active || ms.direction === '') {
          return items;
        }
        return items.sort((a: any, b: any) => {
          return this.sortProcess(a, b, ms.direction);
        });
      };
    return sortFunction;
  }

  sortProcess(a: any, b: any, direction) {
    let comparatorResult = 0;
    if (this.sortingColumn == "standardType") {
      comparatorResult = this.sttSort.SortCRbyStandardType(a, b);
    }
    else if (this.sortingColumn == "paragraphId") {
      comparatorResult = this.sttSort.SortCRbyParagraphId(a, b);
    }
    else if (this.sortingColumn == "topic") {
      comparatorResult = this.sttSort.SortCRbyTopic(a, b);
    }
    else if (this.sortingColumn == "paragraph") {
      comparatorResult = this.sttSort.SortCRbyParagraph(a, b);
    }
    return comparatorResult * (direction == 'asc' ? 1 : -1);
  }

  redirectInlineGlossary() {
    this.commonDataService.showRightPanel.next(true);
    this.commonDataService.rightOverlayOption.next("inline-glossary");
    this.commonDataService.rightPanelWidth.next("rightOverLay_small");
  }

  redirectContentPage(paraID: string, dataLink: string, standardType = "", standardNumber = "", paragraphNumber = "") {
    this.commonDataService.userSession.subscribe(data => {
      this.userRole = data.roles;
    });
    var paragraphId = paraID.split("-");
    if (paragraphId.length == 4) {
      paraID = paragraphId[2] + "-" + paragraphId[3];
    }
    //let url = {
    //  pubId: dataLink.split("\\")[1],
    //  pageId: dataLink.split("\\")[2]
    //}
    //this.commonDataService.rightOverlayContentPageID.next(url);

    //this.commonDataService.showRightPanel.next(true);
    //this.commonDataService.rightOverlayOption.next("ContentPage");
    //this.commonDataService.rightPanelWidth.next("rightOverlay_large");
    let crossRefObj = {
      paragraphID: paraID,
      standardType: standardType,
      standardNumber: standardNumber,
      paragraphNumber: paragraphNumber
    }
    this.commonDataService.crossreferencedParaID.next(crossRefObj);
    this.router.navigateByUrl("/" + dataLink.split("\\")[1] + "/" + dataLink.split("\\")[2]);
  }

  @HostListener('click', ['$event']) click(event: any) {
    event.target.removeAttribute('href');
    var is_inline_glossary_tags_exists = event?.target?.classList?.contains('inline-glossary');
    if (is_inline_glossary_tags_exists) {
      var glossaryId = event?.target?.dataset?.link;
      this.commonDataService.glossaryTermId.next("");
      if (glossaryId != "" && glossaryId != null) {
        this.commonDataService.glossaryTermId.next(glossaryId);
      }
      this.redirectInlineGlossary();
    }

    var is_content_page_tags_exists = event?.target?.classList?.contains('contentpage');
    if (is_content_page_tags_exists) {
      let currentRow;
      let standardType;
      let standardNumber;
      let paragraphNumber;
      let paragraphID;

      let stdType = localStorage.getItem('cross_reference_standardType');
      let stdNum = localStorage.getItem('cross_reference_standardNumber');

      if (stdType || stdNum) {
        currentRow = event?.target?.parentElement?.parentElement?.getElementsByTagName('td');
        // standardType = stdType;
        // standardNumber = stdNum;
        standardType = currentRow[0].innerHTML;
        standardNumber = currentRow[1].innerHTML;
        paragraphNumber = currentRow[2].innerHTML;
        paragraphID = currentRow[3].getElementsByTagName('a')[0].innerHTML;

        localStorage.setItem('cross_reference_standardType', '');
        localStorage.setItem('cross_reference_standardNumber', '');
      }
      else {
        currentRow = event?.target?.parentElement?.parentElement?.getElementsByTagName('td');
        standardType = currentRow[0].innerHTML;
        standardNumber = currentRow[1].innerHTML;
        paragraphNumber = currentRow[2].innerHTML;
        paragraphID = currentRow[3].getElementsByTagName('a')[0].innerHTML;
      }

      this.redirectContentPage(paragraphID, event?.target?.dataset?.link?.toString(), standardType, standardNumber, paragraphNumber);
    }

    var is_pdf_links_tags_exists = event?.target?.classList?.contains('pdf-link');
    var is_licensee_page = this.router.url?.includes('licensee');

    if (is_pdf_links_tags_exists && is_licensee_page) {
      this.openlink.openLinkById(event, true);
    }
    else {
      this.openlink.openLinkById(event);
    }

    var is_download_links_tags_exists = event?.target?.classList?.contains('download-from-s3-link');
    var filename = event?.target?.id;
    if (is_download_links_tags_exists) {
      this.graphQl.DownloadFromS3(filename);
    }

  }

  @HostListener('contextmenu', ['$event']) RightClick(event: any) {
    var is_inline_glossary_tags_exists = event?.target?.classList?.contains('inline-glossary');
    if (is_inline_glossary_tags_exists) {
      //var glossaryId=event?.target?.dataset?.link;
      //this.commonDataService.glossaryTermId.next("");
      //if(glossaryId!="" && glossaryId!=null){
      //  this.commonDataService.glossaryTermId.next(glossaryId);
      //}
      //this.redirectInlineGlossary();
      return false;
    }

    var is_content_page_tags_exists = event?.target?.classList?.contains('contentpage');
    if (is_content_page_tags_exists) {
      let currentRow;
      let standardType;
      let standardNumber;
      let paragraphNumber;
      let paragraphID;

      let stdType = localStorage.getItem('cross_reference_standardType');
      let stdNum = localStorage.getItem('cross_reference_standardNumber');

      if (stdType || stdNum) {
        currentRow = event?.target?.parentElement?.parentElement?.getElementsByTagName('td');
        // standardType = stdType;
        // standardNumber = stdNum;
        standardType = currentRow[0].innerHTML;
        standardNumber = currentRow[1].innerHTML;
        paragraphNumber = currentRow[2].innerHTML;
        paragraphID = currentRow[3].getElementsByTagName('a')[0].innerHTML;

        localStorage.setItem('cross_reference_standardType', '');
        localStorage.setItem('cross_reference_standardNumber', '');
      }
      else {
        currentRow = event?.target?.parentElement?.parentElement?.getElementsByTagName('td');
        standardType = currentRow[0].innerHTML;
        standardNumber = currentRow[1].innerHTML;
        paragraphNumber = currentRow[2].innerHTML;
        paragraphID = currentRow[3].getElementsByTagName('a')[0].innerHTML;
      }

      var paraID = paragraphID;
      var dataLink = event?.target?.dataset?.link?.toString();
      var paragraphId = paraID.split("-");
      if (paragraphId.length == 4) {
        paraID = paragraphId[2] + "-" + paragraphId[3];
      }
      //let url = {
      //  pubId: dataLink.split("\\")[1],
      //  pageId: dataLink.toString().split("\\")[2]
      //}

      let crossRefObj = {
        paragraphID: paraID,
        standardType: standardType,
        standardNumber: standardNumber,
        paragraphNumber: paragraphNumber
      }
      localStorage.setItem("crossreferencedParaID", JSON.stringify(crossRefObj));
      event.target.href = "/" + dataLink.split("\\")[1] + "/" + dataLink.split("\\")[2];
    }

    var is_pdf_links_tags_exists = event?.target?.classList?.contains('pdf-link');
    var is_licensee_page = this.router.url.includes('licensee');

    if (is_pdf_links_tags_exists && is_licensee_page) {
      //this.openlink.openLinkById(event, true);
      let url = '/layoutComponents/getPdf?isSitesBucket=true&fileName=' + event.target.id;
      event.target.href = url;
    }
    else {
      this.openlink.openLinkById(event);
    }

    var is_download_links_tags_exists = event?.target?.classList?.contains('download-from-s3-link');
    var filename = event?.target?.id;
    if (is_download_links_tags_exists) {
      this.graphQl.DownloadFromS3(filename);
    }

  }
}
